import { type FC, type ReactNode } from "react";

import { VideoViewer, reviewedNotification } from "../../lens-preview/components";
import { BadgeAnimated } from "../../shared/components";
import { type LensPreviewMediaItem } from "../../shared/state";
import { LensDetailsIcon } from "../../submit/components/shared/LensDetailsIcon";

import { CTAPreview, ImagePreview, PreviewViewer, lensCtaIcon, videoPreview } from "./LensCtaMediaPreview.styles";
import { LensCtaMediaPreviewBar } from "./LensCtaPreviewBar";

interface LensCtaMediaPreviewProps {
    lensPreview: LensPreviewMediaItem;
    badgeText?: ReactNode;
    lensIconURL: string;
    lensCtaText: string;
}
const makePreviewComponent = (src: string, isVideo: boolean) =>
    isVideo ? <VideoViewer src={src} height="auto" className={videoPreview} /> : <ImagePreview src={src} />;

export const LensCtaMediaPreview: FC<LensCtaMediaPreviewProps> = ({
    lensPreview,
    badgeText,
    lensIconURL,
    lensCtaText,
}) => {
    const { isVideo, url: src } = lensPreview;
    return (
        <PreviewViewer>
            {badgeText && src && <BadgeAnimated className={reviewedNotification}>{badgeText}</BadgeAnimated>}
            {src && makePreviewComponent(src, isVideo)}
            {lensCtaText && (
                <CTAPreview>
                    <span>{lensCtaText}</span>
                </CTAPreview>
            )}
            <LensCtaMediaPreviewBar />
            <LensDetailsIcon className={lensCtaIcon} iconUrl={lensIconURL} />
        </PreviewViewer>
    );
};
